import { Box, Button, Container, Stack, Typography } from "@mui/material";
import { useSpring } from "@react-spring/web";
import { useState } from "react";
import Transition from "../Transition";

export default function Launch() {
  const [inview, setInview] = useState(false);

  const styles = useSpring({
    from: { y: inview ? 400 : 0 },
    to: { y: 0 },
    delay: 200,
    config: { duration: 700 }
  });

  return (
    <Transition setInview={setInview} styles={styles}>
      <Box sx={{ width: "100%" }} id="launch">
        <Container maxWidth="lg" sx={{ borderTop: "1px solid #edebeb", py: 4 }}>
          <Box sx={{ margin: "auto", width: "100%", textAlign: "center" }}>
            <Typography variant="h3">Launch Your Business</Typography>
            <Stack>
              <Typography variant="body">
                Use our customizable, no-code tools to flaunt your brand –
                wherever your audience is.
              </Typography>
              <Typography>
                Create beautiful websites/ Landing Pages Build a custom website,
                <br />
                or use our extensive template library Host a custom domain
                Analyse your traffic with Heat map tools.
                <br /> Hire our specialists and experts at affordable fee 24*7
                Days Support
              </Typography>
              <br />
              <Button
                sx={{ width: 400, maxWidth: "100%", mx: "auto" }}
                variant="contained"
                size="large"
              >
                Register to start free trial
              </Button>
            </Stack>
          </Box>
        </Container>
      </Box>
    </Transition>
  );
}
